import { atom } from "recoil";
import { RecoilKeys } from "./RecoilKeys";

export const phrasesAPIErrorAtom = atom<boolean>({
    key: RecoilKeys.PhrasesAPIError,
    default: false,
});
